<template>
  <div class="statistics">
    <header>
      <el-tooltip effect="dark" content="返回" placement="bottom">
        <button @click="backtrack" style="cursor:pointer" class="returnBtn">
          <i class="el-icon-back"></i>
        </button>
      </el-tooltip>
      <p>项目统计</p>
    </header>
    <main>
      <h3>
        <div :class="isBlock ? 'titActive' : ''" @click="switchover('0')">项目统计</div>
        <!-- <router-link to="/projectHome/interpreter"> -->
        <div :class="!isBlock ? 'titActive' : ''" @click="switchover('1')">{{tabInterpreterName}}</div>
      </h3>
      <div class="topBox">
        <span v-show="isBlock">项目概要：本次项目共计{{projectList.total }}字，重复字数{{projectList.projectRepeat}}字。</span>
        <span v-show="!isBlock && transModel!=1">项目概要：本项目总任务量{{totalWordNum}}字，译员总费用为{{interpreterTotalMoney()}}元</span>
        <button @click="handleDownloadData">统计下载</button>
      </div>
      <!-- 项目统计table 开始-->
      <template v-if="isBlock">
        <el-table ref="projectTable" tooltip-effect="dark" style="width:100%" height="50" class="tabTit">
          <el-table-column align="center" type="index" label="序号" min-width="80"></el-table-column>
          <el-table-column align="center" label="名称" width></el-table-column>
          <el-table-column align="center" label="创建时间" width=""></el-table-column>
          <el-table-column align="center" label="总计" width=""></el-table-column>
          <el-table-column label="0%-49%" width="100"></el-table-column>
          <el-table-column label="50%-74%" width="100"></el-table-column>
          <el-table-column label="75%-84%" width="100"></el-table-column>
          <el-table-column label="85%-99%" width="100"></el-table-column>
          <el-table-column label="100%" width="100"></el-table-column>
          <el-table-column label="101%" width="100"></el-table-column>
          <el-table-column align="center" label="文件内重复" width=""></el-table-column>
          <el-table-column align="center" label="跨文件重复" width=""></el-table-column>
          <el-table-column align="center" label="新建字数" prop="name" width=""></el-table-column>
        </el-table>
      </template>
      <template v-if="isBlock">
        <el-table ref="multipleTable" :data="projectList.transProjectStatisDtoList" tooltip-effect="dark"
          style="width:100%" class="tabMain" v-loading="loading" border>
          <template slot="empty">
            <div id="notDate">
              <img src="../../assets/imgs/memory/no_data.png" alt />
              <p>暂无数据，快去创建吧</p>
            </div>
          </template>
          <el-table-column :resizable="false" align="center" type="index" label="" min-width="80"></el-table-column>
          <el-table-column :resizable="false" align="center" :label="'（项目）' + projectList.name" prop="name" width>
          </el-table-column>
          <el-table-column :resizable="false" align="center" :label="projectList.fileCreateTime+''" prop="createTime"
            width="">
          </el-table-column>
          <el-table-column :resizable="false" align="center" :label="projectList.total+'' || ''" prop="total" width="">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelOne+'' || ''" prop="similarityLevelOne"
            width="100">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelTwo+'' || ''" prop="similarityLevelTwo"
            width="100">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelThree+'' || ''"
            prop="similarityLevelThree" width="100">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelFour+'' || ''"
            prop="similarityLevelFour" width="100">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelFive+'' || ''"
            prop="similarityLevelFive" width="100">
          </el-table-column>
          <el-table-column :resizable="false" :label="projectList.similarityLevelSix+'' || ''" prop="similarityLevelSix"
            width="100">
          </el-table-column>
          <el-table-column align="center" :resizable="false" :label="projectList.fileRepeat+''" prop="fileRepeat"
            width="">
          </el-table-column>
          <el-table-column align="center" :resizable="false" :label="projectList.crossFileRepeat+''"
            prop="crossFileRepeat" width="">
          </el-table-column>
          <el-table-column align="center" :resizable="false" :label="projectList.newWord+''" prop="newWord" width="">
            <template slot-scope="props">
              <p>{{props.row.newWord}}</p>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!-- 项目统计table 结束-->
      <!-- 译员工作量开始 -->
      <template v-if="!isBlock && transModel!=1">
        <interpretertSatistics :tableData="tableData" :loading="loading2"></interpretertSatistics>
      </template>
      <!-- 译员工作量结束 -->
      <!-- 作业开始 -->
      <template v-if="!isBlock && vueEnvionmentName=='school' && transModel==1">
        <assignmentScore :tableData="tableData" :loading="loading2"></assignmentScore>
      </template>
      <!-- 作业结束 -->
    </main>
  </div>
</template>

<script>
// import ExportJsonExcel from 'js-export-excel';
import interpretertSatistics from './interpreter/interpretertSatistics';
import assignmentScore from './interpreter/assignmentScore';
export default {
  name: "statistics",
  props: ["rowName"],
  data() {
    return {
      standard: true,
      tableData: [],
      projectList: {
        fileName: "",
        fileCreateTime: "",
        total: "",
        similarityLevelOne: "",
        similarityLevelTwo: "",
        similarityLevelThree: "",
        similarityLevelFour: "",
        similarityLevelFive: "",
        similarityLevelSix: "",
        fileRepeat: "",
        crossFileRepeat: "",
        newWord: ""
      },
      spanArr: [],
      pos: 0,
      multipleSelection: [], // 存储选中的数组
      butClass: "",
      isShow: false,
      downloadBoxTit: "添加到记忆库",
      topText: "",
      botText: "q",
      isDel: false,
      statisticsTit: ["项目统计", "译员工作量"],
      titActiveI: "0",
      isBlock: true,
      loading: true,
      loading2: true,
      totalWordNum: "",
      projectTitleAry: [
        { label: '名称', prop: 'name' },
        { label: '创建时间', prop: 'createTime' },
        { label: '总计', prop: 'total' },
        { label: '0%-49%', prop: 'similarityLevelOne' },
        { label: '50%-74%', prop: 'similarityLevelTwo' },
        { label: '75%-84%', prop: 'similarityLevelThree' },
        { label: '85%-99%', prop: 'similarityLevelFour' },
        { label: '100%', prop: 'similarityLevelFive' },
        { label: '101%', prop: 'similarityLevelSix' },
        { label: '文件内重复', prop: 'fileRepeat' },
        { label: '跨文件重复', prop: 'crossFileRepeat' },
        { label: '新建字数', prop: 'newWord' },
      ],
      userTitleAry: [
        { label: '项目名称', prop: 'projectName' },
        { label: '任务名称', prop: 'taskName' },
        { label: '任务类型', prop: 'taskType' },
        { label: '完成时间', prop: 'finishTime' },
        { label: '中文字数', prop: 'chineseWordNum' },
        { label: '译员', prop: 'userName' },
        { label: '单价/元', prop: 'salary' },
        { label: '总价/元', prop: 'totalMoney' },
      ],
      vueEnvionmentName: "",
      tabInterpreterName: "译员工作量",
      transModel: this.$route.query.transModel,
    };
  },
  components: {
    interpretertSatistics,
    assignmentScore
  },
  updated() {
    // console.log("00");
  },
  created() {
    this.vueEnvionmentName = process.env.VUE_APP_NAME;
    if (this.transModel == 1) {
      this.tabInterpreterName = "作业分数";
      this.userTitleAry = [
        { label: '任务名称', prop: 'taskName' },
        { label: '任务类型', prop: 'taskType' },
        { label: '完成时间', prop: 'finishTime' },
        { label: '原文字数', prop: 'sourceWordNum' },
        { label: '译文字数', prop: 'targetWordNum' },
        { label: '译员', prop: 'userName' },
        { label: '分数', prop: 'taskScore' },
      ]
    }
    this.getStatis();
    // this.getSpanArr(this.tableData);
  },
  methods: {
    // 修改单价
    salaryChange(row) {
      if (row.salary < 10) {
        row.salary = 10
      } else if (row.salary > 10000) {
        row.salary = 10000
      }
      var params = {
        id: row.id,
        salary: row.salary * 100
      };
      this.catReq1Service("/api/v1/fileTask/task_update", params)
        .then(function (response) {

        });
    },
    getSalary(row) {
      return ((row.chineseWordNum * row.salary) / 1000).toFixed(2);
    },
    interpreterTotalMoney() {
      let num = 0;
      this.tableData.forEach(item => {
        num += item.salary * item.chineseWordNum;
      });
      return (num / 1000).toFixed(2);
    },
    // 译员统计列表
    getTask() {
      var that = this;
      this.catReq1Service(
        `/api/v1/fileTask/file_task_list?projectId=${this.$route.query.projectId}`, {},
        "get"
      )
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.totalWordNum = response.result.totalWordNum;
          that.tableData = response.result.transFileTaskList;
          that.tableData.forEach(item => {
            item.limitTime = that.dateReg(item.limitTime);
            item.salary = item.salary / 100;
            if (item.taskType === 1) {
              item.taskType = "翻译";
            } else if (item.taskType === 2) {
              item.taskType = "审校";
            } else if (item.taskType === 3) {
              item.taskType = "复审";
            }
          });
          that.loading2 = false;

        });
    },
    // 项目统计列表
    getStatis() {
      var that = this;
      this.catReq1Service(
        `/api/v1/project/statis_list?projectId=${this.$route.query.projectId}`, {}, "get"
      )
        .then(function (response) {
          if (!response.success) {
            return;
          }
          that.projectList = response.result;
          that.projectList.fileCreateTime = that.dateReg(
            that.projectList.createTime
          );
          that.projectList.transProjectStatisDtoList.forEach(item => {
            item.createTime = that.dateReg(item.createTime);
          });
          that.loading = false;
        });
    },
    switchover(data) {
      if (data == 0) {
        this.isBlock = true;
      } else {
        this.getTask();
        this.isBlock = false;
      }
    },
    // 返回上一页
    backtrack() {
      this.$router.go(-1);
    },
    // 导出的方法
    async handleDownloadData() { // 导出表格的表头设置
      let columnNames = [];
      let columnValues = [];
      let list, tHeader, filterVal, summary, fileName;
      if (this.isBlock) {
        fileName = this.projectList.name + "-项目统计";
        summary = `项目概要：本次项目共计${this.projectList.total}字，重复字数${this.projectList.projectRepeat}字。`;
        let dataClone = JSON.stringify(this.projectList.transProjectStatisDtoList);
        list = JSON.parse(dataClone);
        list.unshift({
          name: "（项目）" + this.projectList.name,
          createTime: this.projectList.fileCreateTime,
          total: this.projectList.total,
          similarityLevelOne: this.projectList.similarityLevelOne,
          similarityLevelTwo: this.projectList.similarityLevelTwo,
          similarityLevelThree: this.projectList.similarityLevelThree,
          similarityLevelFour: this.projectList.similarityLevelFour,
          similarityLevelFive: this.projectList.similarityLevelFive,
          similarityLevelSix: this.projectList.similarityLevelSix,
          fileRepeat: this.projectList.fileRepeat,
          crossFileRepeat: this.projectList.crossFileRepeat,
          // projectRepeat: this.projectList.projectRepeat,
          newWord: this.projectList.newWord,
        })
        if (list.length < 1) {
          return
        }
        let allColumns = this.projectTitleAry;
        for (let i = 0; i < allColumns.length; i++) {
          columnNames[i] = allColumns[i].label
          columnValues[i] = allColumns[i].prop
        }
        list.push({}, { name: summary })
      } else {
        let dataClone = JSON.stringify(this.tableData);
        list = JSON.parse(dataClone);
        fileName = this.projectList.name + (this.transModel == 1 ? "-作业分数" : "-译员工作量")
        summary = `项目概要：本项目总任务量${this.totalWordNum}字，译员总费用为${this.interpreterTotalMoney()}元`
        if (list.length < 1) {
          return
        }
        let allColumns = this.userTitleAry;
        list.forEach(item => {
          item.totalMoney = ((item.chineseWordNum * item.salary) / 1000).toFixed(2)
          item.salary = item.salary + "元/千字"
        })
        list.push({}, { projectName: summary })
        for (let i = 0; i < allColumns.length; i++) {
          columnNames[i] = allColumns[i].label
          columnValues[i] = allColumns[i].prop
        }
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require('vendor/Export2Excel')
        tHeader = columnNames
        filterVal = columnValues
        let data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, fileName)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 下载
    async tableToExcel() {
      let option = {}, list = [], dataTable = [];
      let obj = {
        '名称': "（项目）" + this.projectList.name,
        '创建时间': this.projectList.fileCreateTime,
        '总计': this.projectList.total,
        '0%-49%': this.projectList.similarityLevelOne,
        '50%-74%': this.projectList.similarityLevelTwo,
        '75%-84%': this.projectList.similarityLevelThree,
        '85%-99%': this.projectList.similarityLevelFour,
        '100%': this.projectList.similarityLevelFive,
        '101%': this.projectList.similarityLevelSix,
        '文件内重复': this.projectList.fileRepeat,
        '跨文件重复': this.projectList.crossFileRepeat,
        // '重复字数': this.projectList.projectRepeat,
        '新建字数': this.projectList.newWord,
      }
      let summary;
      if (this.isBlock) {
        option.fileName = this.projectList.name + "-项目统计"
        summary = `项目概要：本次项目共计${this.projectList.total}字，重复字数${this.projectList.projectRepeat}字。`
        list = this.projectList.transProjectStatisDtoList
        if (list.length < 1) {
          return
        }
        if (list) {
          dataTable.push(obj);
          for (let i = 0; i < list.length; i++) {
            if (list) {
              let obj2 = {
                '名称': list[i].name,
                '创建时间': list[i].createTime,
                '总计': list[i].total,
                '重复字数': list[i].projectRepeat,
                '新建字数': list[i].newWord,
              }
              dataTable.push(obj2);
            }
          }
        }
        // debugger
        dataTable.push({}, { '名称': summary })
        option.datas = [
          {
            sheetData: dataTable,
            sheetName: 'sheet',
            sheetFilter: ['名称', '创建时间', '总计', '重复字数', '新建字数'],
            sheetHeader: ['名称', '创建时间', '总计', '重复字数', '新建字数'],
          }
        ];
      } else {
        option.fileName = this.projectList.name + "-译员工作量"
        summary = `项目概要：本项目总任务量${this.totalWordNum}字，译员总费用为${this.interpreterTotalMoney()}元`

        list = this.tableData
        if (list.length < 1) {
          return
        }
        if (list) {
          // dataTable.push(obj);

          for (let i = 0; i < list.length; i++) {
            if (list) {
              let obj2 = {
                '项目名称': list[i].projectName,
                '任务名称': list[i].taskName,
                '完成时间': list[i].finishTime,
                '中文字数': list[i].chineseWordNum,
                '译员': list[i].userName,
                '单价/元': list[i].salary,
                '总价/元': ((list[i].chineseWordNum * list[i].salary) / 1000).toFixed(2),
              }
              dataTable.push(obj2);
            }
          }
        }
        dataTable.push({}, { '项目名称': summary })
        option.datas = [
          {
            sheetData: dataTable,
            sheetName: 'sheet',
            sheetFilter: ['项目名称', '任务名称', '完成时间', '中文字数', '译员', '单价/元', '总价/元'],
            sheetHeader: ['项目名称', '任务名称', '完成时间', '中文字数', '译员', '单价/元', '总价/元'],
          }
        ];
      }
      // if (data.length<1) {
      //   return
      // }
      let toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    base64(s) { return window.btoa(unescape(encodeURIComponent(s))) },
    // 合并列
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].name === data[i - 1].name) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6) {
        // 对第六列合并
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.statistics {
  height: calc(100% - 40px);
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    .returnBtn {
      width: 48px;
      height: 30px;
      line-height: 30px;
      background: #02A4FD;
      color: #fff;
      position: absolute;
      font-size: 18px;
      left: 30px;
      top: 50%;
      margin-top: -15px;
    }
    p {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  main {
    height: 100%;
    // width: 1660px;
    position: relative;
    // min-height: 789px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-top: 38px;
    padding: 0 20px;
    h3 {
      //   text-align: left;
      height: 30px;
      padding-top: 12px;
      div {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        width: 92px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titActive {
        border-bottom: 1px solid #0288D2;
        color: #0288D2;
      }
    }
    .cell input {
      width: 54px;
    }
    #notDate {
      // 暂无数据
      margin-top: 80px;
    }
    .topBox {
      padding-top: 16px;
      height: 32px;
      span {
        float: left;
        font-size: 14px;
      }
      button {
        float: right;
        width: 92px;
        height: 32px;
        border: 0px;
        background: #5256E9;
        border-radius: 4px;
        margin-right: 0;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    .tabTit {
      /deep/.el-table__body-wrapper {
        display: none;
      }
      /deep/.has-gutter {
        tr {
          th {
            border: 0px;
          }
        }
      }
    }

    .tabMain {
      /deep/.el-table__header-wrapper {
        tr {
          background-color: rgba(224, 237, 252, 1) !important;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
          th:nth-child(1) {
            border-left: 1px solid #ebeef5 !important;
          }
          th {
            border-right: 1px solid #ebeef5;
            background-color: rgba(240, 240, 240, 1) !important;
          }
        }
      }
    }
    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      padding: 0px !important;
      height: 46px;
    }
    .el-table td,
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      border-right: 1px solid #ebeef5;
    }
    // /deep/.el-table td:nth-child(3) {
    //   text-align: left;
    // }
    // /deep/.el-table td:nth-child(4) {
    //   text-align: left;
    // }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    /deep/.el-table {
      border: 0px;
      //   width: 1620px;
      // .ass {
      //   border: 0px;
      //   padding: 5px;
      //   background: transparent;
      // }
      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
    }
    /deep/.el-table:last-child {
      height: calc(100% - 150px);
    }
  }
}
</style>
<style lang="less">
.statistics {
  .el-table__body-wrapper {
    overflow-y: auto;
    height: calc(100% - 65px);
  }
}
</style>
